export const tableColumns = [
  {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 50,
      fixed:'left',
      customRender: (text, record, index) => {
          return index + 1
      },
  },
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
    width: 150,
    fixed:'left',
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "img",
    },
  },

  {
    title: "商品信息",
    dataIndex: "productName",
    key: "productName",
  },

  {
    title: "客户名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
  },

  {
    title: "库存数量",
    dataIndex: "amount",
    key: "amount",
  },

  {
    title: "规格",
    dataIndex: "productProp",
    key: "productProp",
  },

  {
    title: "货格码",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  // {
  //   title: "操作",
  //   dataIndex: "action",
  //   key: "action",
  //   scopedSlots: {
  //     customRender: "action",
  //   },
  // },
];
export const detailColumns = [
  {
    title: "时间",
    dataIndex: "deliveryTaskCode",
    key: "1",
  },
  {
    title: "订单编号",
    dataIndex: "deliveryTaskCode",
    key: "2",
  },
  {
    title: "批次包编码",
    dataIndex: "deliveryTaskCode",
    key: "3",
  },
  {
    title: "当前库存数",
    dataIndex: "deliveryTaskCode",
    key: "4",
  },
  {
    title: "库存变动数",
    dataIndex: "deliveryTaskCode",
    key: "5",
  },
  {
    title: "剩余数",
    dataIndex: "deliveryTaskCode",
    key: "6",
  },
  {
    title: "类型",
    dataIndex: "deliveryTaskCode",
    key: "7",
  },
  {
    title: "操作人",
    dataIndex: "deliveryTaskCode",
    key: "8",
  },
];
